import { combineReducers } from "redux";
import user from "./reducers/user";
import products from "./reducers/products";
import cart from "./reducers/cart";
import loader from "./reducers/loader";
export const reducers = combineReducers({ user, products, cart, loader });
 